import { useEffect } from 'react';
import { scrollToElement } from '../../utils/dom/dom.utils';
import { useRouterLocation } from './location.hook';

// Hook to manage scroll position on route and hash changes
export const useScrollPositionHandler = () => {
	const { pathname, hash } = useRouterLocation();

	// scroll to element on hash change
	useEffect(() => {
		if (hash) {
			scrollToElement(hash);
		}
	}, [hash]);

	// scroll to top on route change
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
};
